var RADIAN = Math.PI / 180;
var toRadian = function (degree) {
  return RADIAN * degree;
};
export default toRadian;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/to-radian.js
// module id = 76
// module chunks = 0